export default __webpack_public_path__ + "static/media/kaira.3729e1fd.png";